/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class CaregiverFinanceAccessRoute extends Route {
  queryParams = {
    includePre: {
      refreshModel: true,
    },
    includeFormer: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    let statusArray = [EnrolmentStatus.CURRENT, EnrolmentStatus.PENDING];
    let includeFormer = false;
    if (params.includePre) {
      statusArray.push(EnrolmentStatus.PRE_ENROLLED);
    }
    if (params.includeFormer) {
      statusArray.push(EnrolmentStatus.FORMER);
      includeFormer = true;
    }
    let statuses = JSON.stringify(statusArray);
    return hash({
      learners: this.store.query('person', {
        type: PersonType.LEARNER,
        statuses,
      }),
      caregivers: this.store.query('person', { type: PersonType.CAREGIVER }),
      accounts: this.store.query('finance/account', {
        isActive: true,
        includeFormer,
      }),
    });
  }
}
